export var UPDATE_SELECTED_SECTION = 'UPDATE_SELECTED_SECTION';